import { sectionHeader } from './index';

export const charges = (bidTasks) => {
  const charges = [];

  if (bidTasks.length) {
    const optionalTasks = bidTasks.filter(task => task.optional);

    charges.push(generateCharges(bidTasks, "Summary of Charges"));
    optionalTasks.length && charges.push(generateCharges(optionalTasks, "Optional Charges"));
  }

  return charges;
};

const generateCharges = (bidTasks, title) => ([
  sectionHeader(title),
  {
    margin: [10, 0, 10, 0],
    stack: bidTasks.map(task => ({
      margin: [2, 2],
      columns: [
          {
              width: "*",
              text: task.title,
          },
          {
              width: 100,
              alignment: "right",
              text: `$${task.subtotal.toFixed(2)}`,
          },
      ]
    })),
  }
]);



// WEBPACK FOOTER //
// ./src/store/generators/PDF/bid/charges.js